// eslint-disable-next-line no-unused-vars
import {
  IDashboardParameters,
  ILabelDashboardGraphData,
  ILabelDashboardRule,
  ILabelDisplay,
  IProjectSettings,
} from './Interfaces';
import {
  ControlState,
  IDashboardPage,
  IDataStorage,
  ILabel,
  Item,
  Project,
  refLinkStyle,
  refLinkTooltip,
  XRTodo,
} from 'matrix-requirements-sdk/client';
import { Plugin } from './Plugin';
import { sdkInstance } from './Instance';

export class DashboardPage implements IDashboardPage<IDashboardParameters> {
  private loadingSelector = '#waitForIt';
  settings: IProjectSettings;
  _root: JQuery;

  private needleList: Item[][];
  private currentFilter = '';
  currentCat = '';

  currentGroups: ILabelDashboardRule[];
  currentLabels: ILabel[];
  charts: c3.ChartAPI[] = [];

  elementsLst: XRTodo[];

  constructor(
    private project: Project,
    private projectStorage: IDataStorage,
    private popupModeOrControl = false,
    private currentFolder: string = undefined,
  ) {
    this.settings = {
      ...Plugin.config.projectSettingsPage.defaultSettings,
      ...project
        .getItemConfig()
        .getSettingJSON(Plugin.config.projectSettingsPage.settingName, {}),
    };
  }

  /** Customize static HTML here */
  private getDashboardDOM(): JQuery {
    return $(this.dashboardDOM);
  }

  render(): JQuery {
    this._root = $("<div class='panel-body-v-scroll fillHeight'/>");

    if (this.popupModeOrControl) {
      $('itemTitleBar addedTitle', this._root).remove();
    }
    const baseControl = $("<div id='itemSelectionLabelDashboard'/>");

    $('.toolbarButtons', sdkInstance.app.itemForm).append(baseControl);

    const select = $(`<div class="dropdown navbar-right" style="">
                <input type="checkbox" id="hideNoLabelSet" /> <small style="margin-right:20px">Hide items without label</small>
                <button class="btn btn-xs dropdown-toggle" type="button" data-toggle="dropdown">
                    <span id="selectedCat" >CAT</span>&nbsp;
                    <span class="caret"></span>
                </button>
                <ul class="dropdown-menu">
                </ul>
                </div>`);

    baseControl.append(select);

    if (this.popupModeOrControl) {
      baseControl.hide();
    }
    //Table filter
    $(document).on('input', '#LabelDashboardInputFilter', (e) => {
      const value = $(e.target).val().toString().toLowerCase();
      $('#itemLabelDashboardList tbody tr').show();

      $('#itemLabelDashboardList tbody tr')
        .filter((_, elem) => {
          return !$(elem).text().toLowerCase().includes(value);
        })
        .hide();
    });

    // No automatic start in case of popup
    if (this.popupModeOrControl) {
      return this._root;
    }
    // Get last opened Notif for this user.

    this.currentCat = this.getLastSelection();

    const categories = this.project.getItemConfig().getCategories();
    let index = 0;

    categories.forEach((cat) => {
      if (sdkInstance.ml.LabelTools.getLabelDefinitions([cat]).length > 0) {
        const item = $(
          `<li class="cat" data-cat="${cat}"><a href="javascript:void(0)">${cat}</a></li>`,
        ).click(() => {
          const hideNoLabelSet = $('#hideNoLabelSet').is(':checked');
          this.SelectionChanged({ cat: cat, hideNoLabel: hideNoLabelSet });
        });
        $('.dropdown-menu', select).append(item);
        if (index == 0) {
          $('#selectedCat').text(cat);
        }
        index++;
      }
    });

    if (!this.currentCat) {
      this.currentCat = $(
        '#itemSelectionLabelDashboard .dropdown-menu li:first',
      ).text();
    }
    const hideNoLabelSet = $('#hideNoLabelSet').is(':checked');

    this.renderProjectPageWithParams(
      { cat: this.currentCat, hideNoLabel: hideNoLabelSet },
      true,
    ).then((container) => {
      $('#dashboardContent', this._root).remove();
      this._root.append(container);
      this.installCopyButtons('Labels Overview for ' + this.currentCat);
    });

    $('#hideNoLabelSet').change(() => {
      const hideNoLabelSet = $('#hideNoLabelSet').is(':checked');
      if (this.currentCat != undefined && this.currentCat != '')
        this.SelectionChanged({
          cat: this.currentCat,
          hideNoLabel: hideNoLabelSet,
        });
    });

    $('#selectedCat', this._root).text(this.currentCat);

    return this._root;
  }

  /** Add interactive element in this function */
  renderProjectPage() {
    sdkInstance.app.itemForm.append(
      sdkInstance.ml.UI.getPageTitle(
        Plugin.config.dashboard.title,
        () => {
          return this._root;
        },
        () => {
          this.onResize();
        },
      ),
    );
    sdkInstance.app.itemForm.append(this.render());
  }

  showLoading() {
    if ($(this.loadingSelector).length === 0) {
      $('#itemDetails').append(
        $('<div class="row spinningWait interactive" id="waitForIt"></div>'),
      );
    }

    $(this.loadingSelector).html('');
    $(this.loadingSelector).append(
      sdkInstance.ml.UI.getSpinningWait('please wait...'),
    );
    $('.spinningWait').show();
  }

  hideLoading() {
    $(this.loadingSelector).remove();
  }

  async renderProjectPageWithParams(
    params: IDashboardParameters,
    interactive: boolean,
  ): Promise<JQuery> {
    const dom = this.getDashboardDOM();

    if (params.cat == undefined) throw new Error('No category defined');

    this.showLoading();

    this.elementsLst = [];
    $('.addedNotifRow', dom).remove();

    //Disable filterByLabel
    this.filterByLabel({ type: '' });

    //1. Get the items to display with MRQL
    const items = await this.getItems(params);
    //2. Render the page

    this.currentCat = params.cat;

    const groups = sdkInstance.ml.LabelTools.getLabelGroups(params.cat);
    const labels: ILabelDashboardRule[] = [];
    this.currentLabels = [];
    groups.forEach((g) => {
      if (g.labelDef.length > 0) {
        const ld: ILabelDisplay[] = [];
        g.labelDef.forEach((o) => {
          this.currentLabels.push(o);
          //Calculate label string
          let displayString = o.label;
          if (o.style.label.on.displayName != '') {
            displayString = o.style.label.on.displayName;
          } else if (o.displayName != '') {
            displayString = o.displayName;
          }

          ld.push({ id: o.label, displayString: displayString });
        });
        labels.push({ type: g.selection, labels: ld, cat: params.cat });
      }
    });
    // console.log(cat,this.currentLabels);

    this.currentFolder = params.folder;
    this.currentGroups = labels;

    this.needleList = [];
    // Was XRTrimNeedle, now is Item[]
    this.needleList.push(items);
    const output = this.renderLabelDashboardTable(items, params, dom);
    $('#LabelDashboardContentPanel', dom).show();
    this.drawChart(output, params, interactive, dom);
    this.hideLoading();
    if (!interactive) $('.interactive').remove();

    return dom;
  }

  public SelectionChanged(params: IDashboardParameters) {
    $('#selectedCat').text(params.cat);

    this.renderProjectPageWithParams(params, true).then((container) => {
      $('#dashboardContent', this._root).remove();
      this._root.append(container);
    });
    //No save in case of popup
    if (!this.popupModeOrControl) this.setLastSelection(params.cat);
  }
  async getItems(params: IDashboardParameters): Promise<Item[]> {
    const query = [];
    if (params.cat != '') {
      query.push(' category=' + params.cat);
    }
    if (params.folder && params.folder != '') {
      query.push('folderm=' + params.folder);
    }
    const mrqlQuery = 'mrql:' + query.join(' AND ');
    const mask = this.project.constructSearchFieldMask({
      includeFields: false,
    });
    return await this.project.searchForItems(
      mrqlQuery,
      sdkInstance.ml.LabelTools.getFilter(),
      true,
      mask,
    );
  }

  renderLabelDashboardTable(
    needles: Item[],
    params: IDashboardParameters,
    dom: JQuery,
  ) {
    const cat = params.cat;
    const hideNoLabelSet = params.hideNoLabel;

    const graphData: ILabelDashboardGraphData = {};

    graphData.allItems = [];
    graphData['nolabelset'] = [];
    this.currentLabels.forEach((element) => {
      graphData[element.label] = [];
    });

    const table = $('#itemLabelDashboardList ', dom);
    const template = $('.template', table);
    $('.addedItem', table).remove();

    if (needles != undefined) {
      needles.forEach((item: Item) => {
        let labels: string[] = [];
        if (item.getLabels() != undefined) {
          // For some reason we don't want parenthesis.
          labels = item.getLabels().map((label) => label.replace(/\(|\)/g, ''));
        }
        if (hideNoLabelSet && labels.length == 0) {
          return;
        }

        let jqueryItem = template.clone();

        jqueryItem.attr('data-id', item.getId());
        jqueryItem = jqueryItem
          .removeClass('template')
          .removeClass('hidden')
          .addClass('addedItem');
        $('.title', jqueryItem).html('');
        $('.label', jqueryItem).html('');

        const itemId = item.getId();

        const link = (<any>$('<div></div>')).refLink({
          id: itemId,
          title: item.getTitle(),
          style: sdkInstance['refLinkStyle'].link,
          tooltip: sdkInstance['refLinkTooltip'].html,
          hideTitle: false,
        });

        $('.title', jqueryItem).data('ref', itemId + '!');

        $('.title', jqueryItem).append(link);

        const container = $('.labelList .labelTools', jqueryItem);

        const ctrlParameter: any = { help: '' };
        ctrlParameter.fieldValue = JSON.stringify(labels);
        ctrlParameter.parameter = { titleBarControl: container };

        const control: any = $('.labelList', jqueryItem);
        control.labelsControl(
          <any>sdkInstance.ml.JSON.setOptions(ctrlParameter, {
            type: cat,
            isItem: true,
            controlState: sdkInstance['ControlState'].Tooltip,
            canEdit: true,
          }),
        );

        labels = labels.filter((l) => {
          return this.currentLabels.find((oo) => oo.label == l);
        });

        // Let find current labels:
        let needleLabels = [];
        if (item.getLabels() != undefined) {
          // For some reason we don't want parenthesis.
          needleLabels = item
            .getLabels()
            .map((label) => label.replace(/\(|\)/g, ''));
        }

        for (let i = 0; i < this.currentGroups.length; i++) {
          if (this.currentGroups[i].labels.length > 0) {
            let labelset = false;

            // Check if labels contains one label of the group
            this.currentGroups[i].labels
              .map((l) => l.id)
              .forEach((groupLabel) => {
                if (needleLabels.includes(groupLabel)) {
                  if (graphData[groupLabel] != undefined) {
                    graphData[groupLabel].push(item);
                  }
                  jqueryItem.addClass('id_' + groupLabel);
                  labelset = true;
                }
              });

            if (labelset == false) {
              if (graphData[i + '_nolabelset'] == undefined)
                graphData[i + '_nolabelset'] = [];

              graphData[i + '_nolabelset'].push(item);
              jqueryItem.addClass(i + '_nolabelset');
            }
          }
        }

        $('tbody', table).append(jqueryItem);
        $('.linkLabelDashboard', jqueryItem).css('color', 'red');
      });
    }

    $('#itemLabelDashboardList tbody tr', dom).show();
    this.filterByLabel({ type: this.currentFilter });
    return graphData;
  }
  getLastSelection(): string {
    const value = sdkInstance.globalMatrix.projectStorage.getItem(
      'lastLabelDashboardSelection',
    );
    if (value != undefined && value != '') {
      return value;
    }
    return '';
  }
  setLastSelection(sel: string) {
    sdkInstance.globalMatrix.projectStorage.setItem(
      'lastLabelDashboardSelection',
      sel,
    );
  }

  installCopyButtons(title: string) {
    $('#LabelDashboardTableHeader i', this._root).remove();
    const saveSize = [];
    sdkInstance.ml.UI.copyBuffer(
      $('#LabelDashboardPieChartTitle', this._root),
      'copy  to clipboard',
      $('.panel-body-v-scroll'),
      this._root,
      (copied: JQuery) => {
        sdkInstance.ml.UI.fixC3ForCopy(copied);
        $('.title', copied).each((i, item) => {
          $(item).text($(item).data('ref'));
        });
        $('.hidden', copied).remove();
        $('#LabelDashboardPieChartTitle', copied).html(
          '<h1>' +
            title +
            '</h1> <span> <b> Date:</b> ' +
            sdkInstance.ml.UI.DateTime.renderCustomerHumanDate(new Date()) +
            '<br/>',
        );
      },
      '',
      () => {
        $('#LabelDashboardContentPanel svg', this._root).each((i, item) => {
          saveSize.push($(item).width());
        });
        this.charts.forEach((chart) => {
          chart.resize({ width: 590 });
        });
        /*()=>{
            savedWidth = $("#overviewPerUser svg").width();
            this.overviewPerUserChart.resize({width:590});
        },()=>{
            this.overviewPerUserChart.resize({width:savedWidth})

        });*/
      },
      () => {
        let i = 0;
        this.charts.forEach((chart) => {
          chart.resize({ width: saveSize[i] });
          i++;
        });
      },
    );
  }

  private colors = [
    sdkInstance.UIToolsConstants.CIColors.BlueZiggurat.color,
    sdkInstance.UIToolsConstants.CIColors.OrangeYellow.color,
    sdkInstance.UIToolsConstants.CIColors.RedPersimmon.color,
    sdkInstance.UIToolsConstants.CIColors.BlueEastBay.color,
    sdkInstance.UIToolsConstants.CIColors.GreenYellow.color,
    sdkInstance.UIToolsConstants.CIColors.BlueDoger.color,
  ];

  generateGraphforXor(
    i: number,
    group: ILabelDashboardRule,
    parameters: IDashboardParameters,
    inputData: ILabelDashboardGraphData,
    interactive: boolean,
    dom: JQuery,
    graph: JQuery,
  ) {
    const columns: any[] = [];

    if (!parameters.hideNoLabel && inputData[i + '_nolabelset'] != undefined) {
      columns.push([
        'No label set',
        inputData[i + '_nolabelset'].length,
        i + '_nolabelset',
        this.colors[0],
      ]);
    }
    let j = 0;
    group.labels.forEach((label) => {
      columns.push([
        label.displayString,
        inputData[label.id] != undefined ? inputData[label.id].length : 0,
        'id_' + label.id,
        this.colors[(j + 1) % this.colors.length],
      ]);
      j++;
    });

    const graphWidth = 250 + Math.ceil(columns.length / 15) * 100;
    const graphHeight = 50 + Math.ceil(columns.length / 15) * 300;
    const maxNameLength = 20;
    for (const col of columns)
      col[0] =
        col[0].substr(0, maxNameLength) +
        (col[0].length > maxNameLength ? '...' : '');

    const params: c3.ChartConfiguration = {
      bindto: graph[0],
      size: {
        width: graphWidth != -1 ? graphWidth : undefined,
        height: graphHeight,
      },
      interaction: {
        enabled: interactive,
      },
      data: {
        columns: columns,
        type: 'donut',
        onclick: (d, i) => {
          setTimeout(() => {
            const c = columns.filter((item) => {
              return item[0] == d.id;
            });
            if (c.length > 0) {
              this.filterByLabel({ type: c[0][2] });
            }
          }, 100);
        },
        color: (color, d: string) => {
          const c = columns.filter((item) => {
            return item[0] == d;
          });
          if (c.length > 0) {
            return c[0][c[0].length - 1];
          }
          return color;
        },
      },
      donut: {
        label: {
          format: (value, ratio, id) => {
            return value;
          },
        },
      },
      legend: {
        position: 'inset',
        inset: {
          anchor: 'top-right',
        },
      },
      tooltip: {
        format: {
          value: (value: any, ratio: any, id: any, index: any) => {
            return value;
          },
        },
      },
    };

    this.charts.push(c3.generate(params));
  }

  generateGraphforOr(
    i: number,
    group: ILabelDashboardRule,
    parameters: IDashboardParameters,
    inputData: ILabelDashboardGraphData,
    interactive: boolean,
    dom: JQuery,
    graph: JQuery,
  ): any {
    const colums: any[] = [];

    const header = ['x'];
    const values: [string | number] = ['Items'];
    const footers = ['footer'];

    if (!parameters.hideNoLabel && inputData[i + '_nolabelset'] != undefined) {
      header.push('No label set');
      values.push(inputData[i + '_nolabelset'].length);
      footers.push(i + '_nolabelset');
    }
    group.labels.forEach((label) => {
      header.push(label.displayString);
      footers.push('id_' + label.id);
      values.push(
        inputData[label.id] != undefined ? inputData[label.id].length : 0,
      );
    });
    colums.push(header);
    colums.push(values);
    colums.push(footers);
    const graphWidth = footers.length * 50;
    const params: c3.ChartConfiguration = {
      bindto: graph[0],
      size: {
        width: graphWidth != -1 ? graphWidth : undefined,
      },
      interaction: {
        enabled: interactive,
      },
      data: {
        columns: colums,
        type: 'bar',
        onclick: (d, i) => {
          setTimeout(() => {
            this.filterByLabel({ type: colums[colums.length - 1][d.x + 1] });
          }, 100);
        },
        x: 'x',
        color: (d: any, i: c3.DataPoint) => {
          {
            return this.colors[i.x % this.colors.length];
          }
        },
        hide: ['footer'],
      },
      axis: {
        x: {
          type: 'category', // this needed to load string x value
        },
      },
      donut: {
        label: {
          format: function (value, ratio, id) {
            return value;
          },
        },
      },
      legend: {
        show: false,
      },
      tooltip: {
        format: {
          value: function (value: any, ratio: any, id: any, index: any) {
            return value;
          },
        },
      },
    };

    this.charts.push(c3.generate(params));
  }

  private drawChart(
    inputData: ILabelDashboardGraphData,
    params: IDashboardParameters,
    interactive: boolean,
    dom: JQuery,
  ) {
    let i = 0;
    $('#LabelDashboardPieChart div', dom).remove();
    const w = 90 / this.currentGroups.length;
    for (const group of this.currentGroups) {
      const graph = $("<div id='graph" + i + "'>");
      $('#LabelDashboardPieChart', dom).append(graph);

      if (group.type == 'xor' || group.type == 'review') {
        this.generateGraphforXor(
          i,
          group,
          params,
          inputData,
          interactive,
          dom,
          graph,
        );
      } else {
        this.generateGraphforOr(
          i,
          group,
          params,
          inputData,
          interactive,
          dom,
          graph,
        );
      }
      i++;
    }

    $('#LabelDashboardPieChart svg', dom).click(() => {
      this.filterByLabel({ type: '' });
    });
    return;
  }

  filterByLabel(filter: any, dom?: JQuery) {
    if (dom == undefined) dom = this._root;

    this.currentFilter = filter.type;
    if (filter.type == '') {
      //Show all
      $('#itemLabelDashboardList tbody tr', dom).show();
    } else {
      $('#itemLabelDashboardList tbody tr', dom).hide();
      $('#itemLabelDashboardList tbody tr.' + filter.type, dom).show();
    }
  }

  onResize() {
    /* Will be triggered when resizing. */
  }

  private dashboardDOM = `<div  id="dashboardContent">
        <style>
        #LabelDashboardPieChart
        {
            scroll-direction: horizontal;
            overflow-x:auto;
            overflow-y:hidden;
        }
        .chart {
            min-height: 350px;
            cursor:pointer;
            display: flex;
        }
        .chart {

        }
        .bigChart
        {
            min-height:700px;
        }
        .labelList .btn[disabled]
        {
            opacity:1 !important;
        }
        </style>
        <div class="row spinningWait interactive" id="waitForIt" ></div>
        <div class="panel-body" id="LabelDashboardContentPanel">

            <div id="">
                <div class="panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title" id="LabelDashboardPieChartTitle">Overview</h3>
                </div>
                <div class="panel-body">
                    <div class="LabelDashboardTitleForCopy"></div>
                    <div id="LabelDashboardPieChart" class="chart"></div>
                </div>
        </div></div>
        <div id="LabelDashboardContent" >
        <div class="row doNotCopy">
            <div class="col-lg-3 ">
                <h3 id="LabelDashboardTableHeader">Item list</h3>
            </div>
            <div class=" col-lg-7">
            </div>
            <div class=" col-lg-2">
            <input type="text" id="LabelDashboardInputFilter" style="margin-bottom:10px;" placeholder="filter..." class="doNotCopy  form-control interactive"></input>
            </div>
        </div>
        <div class="LabelDashboardTitleForCopy"></div>
            <table id="itemLabelDashboardList" class="table table-condensed table-borderless table-hover">
               <thead>
                <tr>
                    <th> id</th>
                    <th> Labels</th>
                </tr>
               </thead>
               <tbody>
                    <tr class="template hidden">
                        <td class="title" >MyITEM : my title ablash </td>
                        <td class="labelList" > <!--<div class="labelContainer labelTools"/>--></td>
                    </tr>
                </tbody>
            </table>
            </div>
        </div>
        </div>
        `;
}
